const LOG_PREFIX = '[tenantBranding]';

export const TENANT_NAME_STORAGE_KEY = 'tenant_name';
export const TENANT_LOGO_URL_STORAGE_KEY = 'tenant_logo_url';

function trimOrEmpty(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function persistField(key: string, value: string): boolean {
  if (value) {
    localStorage.setItem(key, value);
    return true;
  }
  localStorage.removeItem(key);
  return false;
}

export function persistTenantBranding(name: unknown, logoUrl: unknown): void {
  try {
    const tenantName = trimOrEmpty(name);
    const tenantLogoUrl = trimOrEmpty(logoUrl);
    const savedName = persistField(TENANT_NAME_STORAGE_KEY, tenantName);
    const savedLogo = persistField(TENANT_LOGO_URL_STORAGE_KEY, tenantLogoUrl);

    if (savedName || savedLogo) {
      console.info(`${LOG_PREFIX} saved tenant branding`, {
        hasName: savedName,
        hasLogo: savedLogo,
      });
      return;
    }

    console.warn(`${LOG_PREFIX} tenant name and logoUrl empty; using default brand`);
  } catch (err) {
    console.error(`${LOG_PREFIX} failed to persist tenant branding`, err);
  }
}

export function clearTenantBranding(): void {
  try {
    localStorage.removeItem(TENANT_NAME_STORAGE_KEY);
    localStorage.removeItem(TENANT_LOGO_URL_STORAGE_KEY);
    console.info(`${LOG_PREFIX} cleared tenant branding`);
  } catch (err) {
    console.error(`${LOG_PREFIX} failed to clear tenant branding`, err);
  }
}

export function readTenantBranding(): { name: string; logoUrl: string } {
  return {
    name: trimOrEmpty(localStorage.getItem(TENANT_NAME_STORAGE_KEY)),
    logoUrl: trimOrEmpty(localStorage.getItem(TENANT_LOGO_URL_STORAGE_KEY)),
  };
}
